// export const BASEURL = 'http://145.223.18.33:4008'
export const BASEURL = 'https://smartxcrm.co/api'

// export const BASEURL = 'http://localhost:4008/api'
// export const BARCODE_URL = 'http://localhost:3000'
